(function () {
  'use strict';

  if (document.getElementById('bib-launcher')) return;

  const API_URL = 'https://bib-shopify-production.up.railway.app/api/chat';

  // ── Analytics tracking ────────────────────────────────────────────────────
  // Fires an event to BOTH the GTM dataLayer and gtag/GA4, so it's picked up
  // whichever Google setup the storefront uses. Never pass PII (no raw email).
  function bibTrack(eventName, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    } catch (e) {}
    try {
      if (typeof gtag === 'function') gtag('event', eventName, params);
    } catch (e) {}
  }
  // Expose so inline onclick handlers can use it too
  window.bibTrack = bibTrack;

  // ── Inject CSS ──────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    #bib-launcher {
      position: fixed;
      bottom: 24px;
      right: 24px;
      display: flex;
      align-items: center;
      gap: 10px;
      background: linear-gradient(135deg, #1d4ed8, #2563eb);
      border-radius: 50px;
      padding: 12px 20px 12px 14px;
      cursor: pointer;
      box-shadow: 0 4px 24px rgba(37,99,235,0.45);
      z-index: 9997;
      transition: transform 0.2s, box-shadow 0.2s;
      border: none;
      color: white;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }
    #bib-launcher:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 30px rgba(37,99,235,0.55);
    }
    #bib-launcher .bib-launcher-icon {
      animation: bibIconPulse 2.5s ease-in-out infinite;
    }
    @keyframes bibIconPulse {
      0%,100% { opacity: 1; transform: scale(1); }
      50%      { opacity: 0.65; transform: scale(0.88); }
    }
    #bib-launcher .bib-launcher-pulse {
      position: absolute;
      top: -3px; right: -3px;
      width: 12px; height: 12px;
      background: #22c55e;
      border-radius: 50%;
      border: 2px solid #1d4ed8;
    }
    #bib-launcher .bib-launcher-icon {
      width: 32px; height: 32px;
      background: rgba(255,255,255,0.15);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
    }
    #bib-launcher .bib-launcher-text { display: flex; flex-direction: column; line-height: 1.2; }
    #bib-launcher .bib-launcher-title { font-size: 14px; font-weight: 700; letter-spacing: 0.3px; }
    #bib-launcher .bib-launcher-sub { font-size: 11px; opacity: 0.8; }

    #bib-widget {
      position: fixed;
      bottom: 0; right: 24px;
      width: 380px;
      max-height: calc(100vh - 80px);
      height: 520px;
      background: rgba(30, 41, 59, 0.97);
      backdrop-filter: blur(10px);
      border-radius: 16px;
      border: 1px solid rgba(148, 163, 184, 0.2);
      display: none;
      flex-direction: column;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
      overflow: hidden;
      z-index: 9998;
      transform: scale(0.95) translateY(10px);
      opacity: 0;
      transition: transform 0.25s ease, opacity 0.25s ease;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }
    #bib-widget.bib-open {
      display: flex;
      transform: scale(1) translateY(0);
      opacity: 1;
    }
    #bib-widget.bib-animating { display: flex; }
    #bib-widget.bib-expanded {
      width: min(680px, calc(100vw - 48px));
      height: calc(100vh - 80px);
    }

    @media (max-width: 480px) {
      #bib-widget {
        bottom: 0; right: 0; left: 0;
        width: 100%; height: 72vh;
        max-height: 72vh;
        border-radius: 20px 20px 0 0;
        border-bottom: none;
      }
      #bib-widget.bib-expanded { height: 92vh; max-height: 92vh; }
      #bib-launcher { bottom: 16px; right: 16px; padding: 10px 16px 10px 12px; }
      #bib-launcher .bib-launcher-sub { display: none; }
      #bib-mobile-handle { display: flex; }
    }
    #bib-mobile-handle {
      display: none;
      justify-content: center;
      align-items: center;
      gap: 8px;
      padding: 10px 16px 6px;
      cursor: pointer;
      flex-shrink: 0;
      background: transparent;
      border: none;
      width: 100%;
      -webkit-tap-highlight-color: transparent;
    }
    #bib-mobile-handle .bib-handle-bar {
      width: 40px; height: 4px;
      background: rgba(148,163,184,0.4);
      border-radius: 4px;
    }
    #bib-mobile-handle .bib-handle-label {
      font-size: 11px; color: rgba(148,163,184,0.6);
      font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    }

    #bib-widget .bib-header {
      padding: 14px 16px;
      background: linear-gradient(135deg, rgba(30,58,138,0.4), rgba(59,130,246,0.2));
      border-bottom: 1px solid rgba(59,130,246,0.3);
      display: flex; align-items: center; gap: 12px;
      flex-shrink: 0;
    }
    #bib-widget .bib-header-text h1 { font-size: 16px; font-weight: 600; color: #f1f5f9; margin: 0; letter-spacing: 0.5px; }
    #bib-widget .bib-header-text p { font-size: 12px; color: #93c5fd; margin: 2px 0 0 0; font-weight: 500; }
    #bib-widget .bib-messages {
      flex: 1; overflow-y: auto; padding: 16px;
      display: flex; flex-direction: column; gap: 12px;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }
    #bib-widget .bib-messages::-webkit-scrollbar { width: 6px; }
    #bib-widget .bib-messages::-webkit-scrollbar-track { background: rgba(148,163,184,0.1); border-radius: 10px; }
    #bib-widget .bib-messages::-webkit-scrollbar-thumb { background: rgba(148,163,184,0.3); border-radius: 10px; }

    #bib-widget .bib-message { display: flex; gap: 8px; animation: bibFadeIn 0.3s ease-in; }
    @keyframes bibFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    #bib-widget .bib-message.bib-user { justify-content: flex-end; }
    #bib-widget .bib-message-content {
      max-width: 85%; padding: 10px 14px; border-radius: 12px;
      word-wrap: break-word; line-height: 1.4; font-size: 14px;
    }
    #bib-widget .bib-message.bib-bot .bib-message-content {
      background: rgba(51,65,85,0.5); border: 1px solid rgba(148,163,184,0.15); color: #f1f5f9;
    }
    #bib-widget .bib-message.bib-user .bib-message-content {
      background: linear-gradient(135deg, #3b82f6, #2563eb); color: white;
    }

    #bib-widget .bib-thinking-box {
      background: rgba(51,65,85,0.5); border: 1px solid rgba(148,163,184,0.15);
      color: #94a3b8; padding: 10px 14px; border-radius: 12px;
      max-width: 85%; font-size: 13px; font-style: italic;
      display: flex; align-items: center; gap: 6px;
    }
    .bib-thinking-dot {
      display: inline-block; width: 4px; height: 4px; border-radius: 50%;
      background: #60a5fa; animation: bibPulse 1.4s infinite;
    }
    .bib-thinking-dot:nth-child(2) { animation-delay: 0.2s; }
    .bib-thinking-dot:nth-child(3) { animation-delay: 0.4s; }
    @keyframes bibPulse { 0%,60%,100% { opacity: 0.3; } 30% { opacity: 1; } }

    #bib-widget .bib-product-card {
      background: rgba(51,65,85,0.3); border: 1px solid rgba(59,130,246,0.25);
      border-radius: 12px; padding: 12px; width: 160px; flex-shrink: 0; overflow: visible; position: relative;
    }
    #bib-widget .bib-product-link {
      width: 100%; padding: 8px 12px;
      background: linear-gradient(135deg, rgba(59,130,246,0.2), rgba(96,165,250,0.1));
      border: 1px solid rgba(59,130,246,0.4); color: #60a5fa;
      text-decoration: none; border-radius: 8px; font-size: 12px;
      text-align: center; display: block; font-weight: 500; transition: all 0.2s;
    }
    #bib-widget .bib-product-link:hover { background: linear-gradient(135deg, rgba(59,130,246,0.3), rgba(96,165,250,0.2)); border-color: rgba(59,130,246,0.6); }

    #bib-widget .bib-escalation-banner {
      background: linear-gradient(135deg, rgba(34,197,94,0.1), rgba(34,197,94,0.05));
      border: 1px solid rgba(34,197,94,0.3); border-radius: 10px;
      padding: 10px 12px; max-width: 85%; margin-top: 8px;
    }
    #bib-widget .bib-escalation-text { font-size: 12px; color: #86efac; font-weight: 500; margin-bottom: 8px; }
    #bib-widget .bib-whatsapp-btn {
      display: block; padding: 8px 12px; background: #25d366; color: white;
      text-decoration: none; border-radius: 8px; font-size: 12px;
      text-align: center; font-weight: 600; transition: all 0.2s; border: none; cursor: pointer;
    }
    #bib-widget .bib-whatsapp-btn:hover { background: #1fae52; }

    #bib-widget .bib-quote-btn {
      display: block; width: calc(100% - 32px); margin: 0 16px 8px;
      padding: 10px 16px; background: linear-gradient(135deg, #1d4ed8, #2563eb);
      color: white; border: none; border-radius: 10px; font-size: 13px;
      font-weight: 600; cursor: pointer; text-align: center;
      transition: all 0.2s; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }
    #bib-widget .bib-quote-btn:hover { background: linear-gradient(135deg, #1e40af, #1d4ed8); transform: translateY(-1px); }

    #bib-widget .bib-input-area {
      padding: 12px;
      background: linear-gradient(180deg, rgba(15,23,42,0.3), rgba(15,23,42,0.7));
      border-top: 1px solid rgba(148,163,184,0.1);
      flex-shrink: 0; display: flex; gap: 6px;
    }
    #bib-widget .bib-input-container {
      flex: 1; display: flex; align-items: center;
      background: rgba(51,65,85,0.5); border: 1px solid rgba(148,163,184,0.2);
      border-radius: 20px; padding: 0 12px; transition: border-color 0.2s;
    }
    #bib-widget .bib-input-container:focus-within { border-color: rgba(59,130,246,0.6); }
    #bib-widget .bib-input {
      flex: 1; background: transparent; border: none; color: #f1f5f9;
      padding: 8px 0; font-size: 16px; outline: none;
    }
    @media (min-width: 481px) {
      #bib-widget .bib-input { font-size: 13px; }
    }
    #bib-widget .bib-input::placeholder { color: #64748b; }
    #bib-widget .bib-send-btn {
      background: linear-gradient(135deg, #3b82f6, #2563eb); color: white;
      border: none; border-radius: 18px; padding: 6px 16px;
      font-size: 12px; font-weight: 600; cursor: pointer;
      transition: all 0.2s; flex-shrink: 0;
      box-shadow: 0 4px 12px rgba(59,130,246,0.3);
    }
    #bib-widget .bib-send-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(59,130,246,0.4); }
    #bib-widget .bib-send-btn:disabled { opacity: 0.6; cursor: not-allowed; }
    #bib-widget .bib-mic-btn {
      background: rgba(51,65,85,0.5); border: 1px solid rgba(148,163,184,0.2);
      border-radius: 50%; width: 40px; height: 40px;
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; flex-shrink: 0; transition: background 0.2s;
    }
    #bib-widget .bib-icon-btn {
      background: rgba(255,255,255,0.08); border: none; border-radius: 50%;
      width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;
      cursor: pointer; color: #94a3b8; flex-shrink: 0; padding: 0; transition: color 0.2s;
    }
    #bib-widget .bib-icon-btn:hover { color: #f1f5f9; }
  `;
  document.head.appendChild(style);

  // ── Build HTML ──────────────────────────────────────────────────────────
  const BRAIN_SVG = `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
    <path d="M10 14C10 10.7 12.2 8 15 8C17.8 8 20 10.7 20 14" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"/>
    <path d="M10 14C10 17.3 12.2 20 15 20C17.8 20 20 17.3 20 14" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"/>
    <circle cx="11" cy="14" r="1.5" fill="white"/><circle cx="19" cy="14" r="1.5" fill="white"/>
    <path d="M13 23C13 24.1 13.9 25 15 25C16.1 25 17 24.1 17 23" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"/>
  </svg>`;

  const BRAIN_SVG_HEADER = `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <defs><linearGradient id="bibBrainGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#3b82f6;stop-opacity:1"/>
      <stop offset="100%" style="stop-color:#60a5fa;stop-opacity:1"/>
    </linearGradient></defs>
    <path d="M10 14C10 10.7 12.2 8 15 8C17.8 8 20 10.7 20 14" stroke="url(#bibBrainGrad)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 14C10 17.3 12.2 20 15 20C17.8 20 20 17.3 20 14" stroke="url(#bibBrainGrad)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="11" cy="14" r="1.5" fill="#93c5fd"/><circle cx="19" cy="14" r="1.5" fill="#93c5fd"/>
    <path d="M13 23C13 24.1 13.9 25 15 25C16.1 25 17 24.1 17 23" stroke="url(#bibBrainGrad)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  const MIC_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color:#94a3b8;">
    <rect x="9" y="2" width="6" height="12" rx="3"></rect>
    <path d="M5 10a7 7 0 0 0 14 0"></path>
    <line x1="12" y1="19" x2="12" y2="22"></line>
    <line x1="9" y1="22" x2="15" y2="22"></line>
  </svg>`;

  // Launcher
  const launcher = document.createElement('button');
  launcher.id = 'bib-launcher';
  launcher.setAttribute('aria-label', 'Open B.I.B chat');
  launcher.innerHTML = `
    <div class="bib-launcher-pulse"></div>
    <div class="bib-launcher-icon">${BRAIN_SVG}</div>
    <div class="bib-launcher-text">
      <span class="bib-launcher-title">Ask B.I.B</span>
      <span class="bib-launcher-sub">Brand It Brain · by James</span>
    </div>`;
  document.body.appendChild(launcher);

  // Widget panel
  const widget = document.createElement('div');
  widget.id = 'bib-widget';
  widget.innerHTML = `
    <button id="bib-mobile-handle" aria-label="Minimise chat">
      <div class="bib-handle-bar"></div>
      <span class="bib-handle-label">tap to minimise</span>
    </button>
    <div class="bib-header">
      ${BRAIN_SVG_HEADER}
      <div class="bib-header-text">
        <h1>B.I.B <span style="font-size:11px;font-weight:400;opacity:0.6;letter-spacing:0.5px;">by James</span></h1>
        <p>Brand It Brain</p>
      </div>
      <div style="display:flex;align-items:center;gap:6px;margin-left:auto;flex-shrink:0;">
        <a href="https://api.whatsapp.com/send/?phone=447822032344" target="_blank" onclick="window.bibTrack&&window.bibTrack('chat_whatsapp_clicked',{event_category:'BIB Chatbot',source:'header'})" style="background:#25D366;color:white;padding:6px 11px;border-radius:20px;text-decoration:none;font-size:12px;font-weight:bold;white-space:nowrap;">WhatsApp</a>
        <button id="bib-expand-btn" class="bib-icon-btn" title="Expand"><span id="bib-expand-icon" style="font-size:14px;line-height:1;">⤢</span></button>
        <button id="bib-close-btn" class="bib-icon-btn" aria-label="Close" style="font-size:15px;">✕</button>
      </div>
    </div>
    <div class="bib-messages" id="bib-messages"></div>
    <div class="bib-input-area">
      <div class="bib-input-container">
        <input type="text" class="bib-input" id="bib-input" placeholder="Ask me anything..." autocomplete="off"/>
      </div>
      <button class="bib-mic-btn" id="bib-mic-btn" title="Speak your question">${MIC_SVG}</button>
      <button class="bib-send-btn" id="bib-send-btn">Send</button>
    </div>`;
  document.body.appendChild(widget);

  // ── State ───────────────────────────────────────────────────────────────
  const messagesDiv = document.getElementById('bib-messages');
  const inputField  = document.getElementById('bib-input');
  const sendBtn     = document.getElementById('bib-send-btn');
  const closeBtn    = document.getElementById('bib-close-btn');
  const mobileHandle = document.getElementById('bib-mobile-handle');
  const expandBtn   = document.getElementById('bib-expand-btn');
  const expandIcon  = document.getElementById('bib-expand-icon');
  const STORAGE_KEY = 'bib_chat';
  const EXPIRY_MS = 2 * 60 * 60 * 1000; // 2 hours

  function loadSession() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() > data.expiry) { localStorage.removeItem(STORAGE_KEY); return null; }
      return data;
    } catch(e) { return null; }
  }

  function saveSession() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        history: conversationHistory,
        messages: savedMessages,
        shownHandles: shownProductHandles,
        expiry: Date.now() + EXPIRY_MS
      }));
    } catch(e) {}
  }

  var session = loadSession();
  var conversationHistory = session ? session.history : [];
  var savedMessages = session ? session.messages : []; // [{type:'bot'|'user', text:string}]
  var shownProductHandles = session && session.shownHandles ? session.shownHandles : []; // handles already shown, so "show me more" returns fresh ones
  var greeted = conversationHistory.length > 0;
  var isExpanded = false;
  var lastSearchQuery = '';   // tracks the last search so chips can refine it
  var compareMode = false;    // whether compare tickboxes are active
  var compareSelections = []; // product objects selected for comparison

  // ── Lead generation state ────────────────────────────────────────────────
  var leadCaptureActive = false;
  var productSearchCount = 0;
  var inactivityTimer = null;
  var INACTIVITY_MS = 90000; // 90 seconds

  // Track pages visited this session
  var pagesVisited = (function() {
    var pages = [];
    var entry = document.title + ' (' + window.location.pathname + ')';
    pages.push(entry);
    return pages;
  })();

  // ── Chip sets per product type ───────────────────────────────────────────
  var CHIP_SETS = {
    'Jacket': [
      { label: 'Waterproof only', add: 'waterproof' },
      { label: 'Lightweight', add: 'lightweight' },
      { label: 'Thermal / Insulated', add: 'insulated' },
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Show more', action: 'more' }
    ],
    'Gilet': [
      { label: 'Waterproof only', add: 'waterproof' },
      { label: 'Thermal / Insulated', add: 'insulated' },
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Show more', action: 'more' }
    ],
    'T-Shirt': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Organic', add: 'organic' },
      { label: 'Polyester', add: 'polyester' },
      { label: 'Cotton', add: 'cotton' },
      { label: 'Show more', action: 'more' }
    ],
    'Hoodie': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Organic', add: 'organic' },
      { label: 'Heavyweight', add: 'heavyweight' },
      { label: 'Show more', action: 'more' }
    ],
    'Sweatshirt': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Organic', add: 'organic' },
      { label: 'Show more', action: 'more' }
    ],
    'Polo': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Organic', add: 'organic' },
      { label: 'Long sleeve', add: 'long sleeve' },
      { label: 'Show more', action: 'more' }
    ],
    'Trouser': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Show more', action: 'more' }
    ],
    '_default': [
      { label: "Men's", add: 'mens' },
      { label: "Women's", add: 'womens' },
      { label: 'Show more', action: 'more' }
    ]
  };

  // ── Capture page context to send with every API call ────────────────────
  (function() {
    var path = window.location.pathname.toLowerCase();
    var ctx = { path: path, title: document.title };
    if (path.match(/^\/products\//)) {
      var h1 = document.querySelector('h1');
      ctx.type = 'product';
      ctx.productName = h1 ? h1.textContent.trim() : document.title;
      // Also grab product handle from URL
      ctx.productHandle = path.replace('/products/', '').split('?')[0];
    } else if (path.includes('/collections/')) {
      ctx.type = 'collection';
      ctx.collectionName = path.split('/collections/')[1].replace(/-/g, ' ').replace(/\/$/, '');
    } else {
      ctx.type = 'other';
    }
    window.__bibPageContext = ctx;
  })();

  // ── Page-aware greeting ──────────────────────────────────────────────────
  function getPageGreeting() {
    var path = window.location.pathname.toLowerCase();
    var title = document.title || '';

    // Specific product page
    var productMatch = path.match(/^\/products\/(.+)/);
    if (productMatch) {
      var h1 = document.querySelector('h1');
      var productName = h1 ? h1.textContent.trim() : 'this one';
      return "Spotted you're looking at " + productName + ". Want to know more about it, or shall I find you something similar?";
    }
    // Collections
    if (path.includes('/collections/jackets') || path.includes('/collections/outerwear')) return "Looking for a jacket? Tell me what you need it for — workwear, outdoor, smart — and I'll find the right one.";
    if (path.includes('/collections/t-shirts') || path.includes('/collections/tees')) return "After a tee? Tell me the style, colour, or how many you need and I'll point you in the right direction.";
    if (path.includes('/collections/polo')) return "Browsing polos? Tell me the colour, budget, or brand you're after and I'll narrow it down.";
    if (path.includes('/collections/hoodies') || path.includes('/collections/sweatshirts')) return "Looking at midlayers? Tell me what you need — warmth, branded look, or budget — and I'll help.";
    if (path.includes('/collections/workwear-bundles') || path.includes('/collections/bundles') || path.includes('/workwear-bundles')) return "Building a bundle? Tell me how many people and what garments you're after and I'll help you put it together.";
    if (path.includes('/collections/hi-vis') || path.includes('/collections/high-visibility')) return "After hi-vis? Tell me the class you need or how many you're ordering and I'll find the right options.";
    if (path.includes('/collections/headwear') || path.includes('/collections/caps')) return "After headwear? Caps, beanies, bucket hats — tell me what you need and I'll find it.";
    if (path.includes('/collections/')) {
      // Generic collection — extract name from path
      var collName = path.split('/collections/')[1].replace(/-/g, ' ').replace(/\/$/, '');
      return "Browsing " + collName + "? Tell me what you're after and I'll help you find the right fit.";
    }
    // Default homepage / other
    return "Hey! Looking for branded workwear? Tell me what you need and I'll find the right fit — or ask me anything about our products.";
  }

  // ── Messages ────────────────────────────────────────────────────────────
  function addGreeting() {
    var base = getPageGreeting();
    // If the customer is signed into their Shopify account, greet them by name
    var cust = window.__bibCustomer;
    if (cust && cust.firstName) base = 'Alright ' + cust.firstName + '! ' + base;
    addBotMessage(base);
  }

  // Desktop-only: open after 60 seconds of idle (no mouse/touch/key activity)
  // Never fires on mobile (fills the screen), never fires more than once per session
  (function() {
    if (window.innerWidth < 768) return;
    if (sessionStorage.getItem('bib-auto-opened')) return;
    var idleOpenTimer = null;
    function scheduleIdleOpen() {
      clearTimeout(idleOpenTimer);
      idleOpenTimer = setTimeout(function() {
        if (!widget.classList.contains('bib-open') && !sessionStorage.getItem('bib-auto-opened')) {
          sessionStorage.setItem('bib-auto-opened', '1');
          openWidget();
        }
      }, 60000);
    }
    scheduleIdleOpen();
    ['mousemove','keydown','scroll','click','touchstart'].forEach(function(ev) {
      document.addEventListener(ev, scheduleIdleOpen, { passive: true });
    });
    // Once the widget has been manually opened, cancel idle timer for good
    widget.addEventListener('bib-opened', function() { clearTimeout(idleOpenTimer); });
  }());

  function addBotMessage(text, skipSave) {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    const content = document.createElement('div');
    content.className = 'bib-message-content';
    content.style.whiteSpace = 'pre-wrap';
    content.textContent = text;
    msg.appendChild(content);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
    if (!skipSave) { savedMessages.push({ type: 'bot', text: text }); saveSession(); }
  }

  function addUserMessage(text, skipSave) {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-user';
    const content = document.createElement('div');
    content.className = 'bib-message-content';
    content.textContent = text;
    msg.appendChild(content);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
    if (!skipSave) { savedMessages.push({ type: 'user', text: text }); saveSession(); }
  }

  function addThinkingBox() {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    msg.id = 'bib-thinking-box';
    const box = document.createElement('div');
    box.className = 'bib-thinking-box';
    box.innerHTML = 'thinking<span class="bib-thinking-dot"></span><span class="bib-thinking-dot"></span><span class="bib-thinking-dot"></span>';
    msg.appendChild(box);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  function removeThinkingBox() {
    const el = document.getElementById('bib-thinking-box');
    if (el) el.remove();
  }

  function addProductCards(products, skipSave) {
    // Remember what we've shown so a later "show me more" can skip these
    products.forEach(function(p) {
      if (p && p.handle && shownProductHandles.indexOf(p.handle) === -1) shownProductHandles.push(p.handle);
    });
    if (shownProductHandles.length > 100) shownProductHandles = shownProductHandles.slice(-100);
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;max-width:100%;padding:4px 0;';
    products.forEach(function(product) {
      const card = document.createElement('div');
      card.className = 'bib-product-card';
      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.name;
        img.style.cssText = 'width:100%;height:140px;object-fit:cover;border-radius:8px;margin-bottom:8px;';
        card.appendChild(img);
      }
      const title = document.createElement('h3');
      title.textContent = product.name;
      title.style.cssText = 'font-size:12px;color:#f1f5f9;margin:0 0 4px 0;';
      card.appendChild(title);
      if (product.price) {
        const price = document.createElement('p');
        price.textContent = product.price;
        price.style.cssText = 'font-size:13px;font-weight:600;color:#60a5fa;margin:0 0 8px 0;';
        card.appendChild(price);
      }
      const link = document.createElement('a');
      link.href = product.url;
      link.target = '_blank';
      link.className = 'bib-product-link';
      link.textContent = 'View on Shop';
      card.appendChild(link);

      // Compare tickbox — always visible, empty circle until selected
      var tick = document.createElement('div');
      tick.className = 'bib-compare-tick';
      tick.style.cssText = 'position:absolute;top:7px;right:7px;width:20px;height:20px;border-radius:50%;background:rgba(15,23,42,0.7);border:2px solid rgba(96,165,250,0.5);color:transparent;font-size:11px;font-weight:700;text-align:center;line-height:16px;cursor:pointer;transition:all 0.15s;';
      tick.textContent = '✓';

      function toggleCard() {
        var idx = compareSelections.findIndex(function(p) { return p.handle === product.handle; });
        if (idx >= 0) {
          compareSelections.splice(idx, 1);
          tick.style.background = 'rgba(15,23,42,0.7)';
          tick.style.borderColor = 'rgba(96,165,250,0.5)';
          tick.style.color = 'transparent';
          card.style.outline = '';
        } else if (compareSelections.length < 3) {
          compareSelections.push(product);
          tick.style.background = '#2563eb';
          tick.style.borderColor = '#2563eb';
          tick.style.color = '#fff';
          card.style.outline = '2px solid #2563eb';
        }
        updateCompareBtn();
      }

      tick.addEventListener('click', function(e) { e.stopPropagation(); toggleCard(); });
      card.addEventListener('click', function(e) {
        if (e.target === link || link.contains(e.target)) return;
        toggleCard();
      });
      card.style.cursor = 'pointer';
      card.appendChild(tick);
      wrapper.appendChild(card);
    });
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    msg.appendChild(wrapper);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
    if (!skipSave) {
      savedMessages.push({ type: 'products', products: products });
      saveSession();
    }
  }

  // ── Quick reply chips + compare prompt ──────────────────────────────────
  var activeChipRow = null;
  var compareBtn = null;

  function updateCompareBtn() {
    if (!compareBtn) return;
    if (compareSelections.length >= 2) {
      compareBtn.style.opacity = '1';
      compareBtn.style.pointerEvents = 'auto';
      compareBtn.textContent = 'Compare ' + compareSelections.length + ' products';
    } else {
      compareBtn.style.opacity = '0.4';
      compareBtn.style.pointerEvents = 'none';
      compareBtn.textContent = 'Compare selected';
    }
  }

  function showChips(productType, searchQuery) {
    // Remove previous chip row if any
    if (activeChipRow && activeChipRow.parentNode) activeChipRow.parentNode.removeChild(activeChipRow);
    compareMode = false;
    compareSelections = [];

    var chips = (CHIP_SETS[productType] || CHIP_SETS['_default']).slice();
    var queryLower = (searchQuery || '').toLowerCase();

    // Hide chips whose filter is already applied
    chips = chips.filter(function(c) {
      if (!c.add) return true;
      return queryLower.indexOf(c.add) === -1;
    });

    if (chips.length === 0) return;

    var row = document.createElement('div');
    row.className = 'bib-message bib-bot';
    var inner = document.createElement('div');
    inner.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;padding:2px 0;';

    chips.forEach(function(chip) {
      var btn = document.createElement('button');
      btn.textContent = chip.label;
      btn.style.cssText = 'background:rgba(37,99,235,0.15);border:1px solid rgba(96,165,250,0.4);color:#93c5fd;font-size:12px;padding:5px 11px;border-radius:20px;cursor:pointer;transition:all 0.15s;white-space:nowrap;';
      btn.addEventListener('mouseenter', function() { btn.style.background = 'rgba(37,99,235,0.35)'; });
      btn.addEventListener('mouseleave', function() { btn.style.background = 'rgba(37,99,235,0.15)'; });
      btn.addEventListener('click', function() {
        if (chip.action === 'more') {
          inputField.value = searchQuery + ' show more';
          sendMessage();
        } else {
          inputField.value = searchQuery + ' ' + chip.add;
          sendMessage();
        }
        if (row.parentNode) row.parentNode.removeChild(row);
        if (comparePromptEl && comparePromptEl.parentNode) comparePromptEl.parentNode.removeChild(comparePromptEl);
        activeChipRow = null;
      });
      inner.appendChild(btn);
    });

    row.appendChild(inner);
    messagesDiv.appendChild(row);
    activeChipRow = row;

    // Compare prompt — always visible, one line, button greys until 2+ selected
    var comparePromptEl = document.createElement('div');
    comparePromptEl.className = 'bib-message bib-bot';
    var promptInner = document.createElement('div');
    promptInner.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:2px 0 4px;';

    var promptLabel = document.createElement('span');
    promptLabel.textContent = 'Want to compare any of these?';
    promptLabel.style.cssText = 'font-size:12px;color:#94a3b8;';

    compareBtn = document.createElement('button');
    compareBtn.textContent = 'Compare selected';
    compareBtn.style.cssText = 'background:#1d4ed8;color:#fff;font-size:12px;font-weight:600;padding:5px 12px;border-radius:16px;border:none;cursor:pointer;opacity:0.35;pointer-events:none;transition:all 0.2s;';
    compareBtn.addEventListener('click', function() {
      if (compareSelections.length < 2) return;
      var names = compareSelections.map(function(p, i) { return (i+1) + '. ' + p.name; }).join(', ');
      inputField.value = 'Compare these for me: ' + names;
      compareSelections = [];
      document.querySelectorAll('.bib-product-card').forEach(function(c) { c.style.outline = ''; });
      if (row.parentNode) row.parentNode.removeChild(row);
      if (comparePromptEl.parentNode) comparePromptEl.parentNode.removeChild(comparePromptEl);
      activeChipRow = null;
      sendMessage();
    });

    promptInner.appendChild(promptLabel);
    promptInner.appendChild(compareBtn);
    comparePromptEl.appendChild(promptInner);
    messagesDiv.appendChild(comparePromptEl);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  function addInstagramPosts(posts) {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:grid;grid-template-columns:repeat(3,1fr);gap:6px;max-width:100%;';
    posts.forEach(function(post) {
      const a = document.createElement('a');
      a.href = post.url;
      a.target = '_blank';
      a.title = post.caption ? post.caption.slice(0, 80) : 'View on Instagram';
      a.style.cssText = 'display:block;border-radius:8px;overflow:hidden;aspect-ratio:1;';
      const img = document.createElement('img');
      img.src = post.image;
      img.alt = 'Brand It Essex work';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      a.appendChild(img);
      wrapper.appendChild(a);
    });
    const label = document.createElement('div');
    label.style.cssText = 'font-size:11px;color:#64748b;margin-top:6px;text-align:center;';
    label.textContent = '📸 Recent work — tap any photo to view on Instagram';
    msg.appendChild(wrapper);
    msg.appendChild(label);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  function addGoogleReviews(reviews) {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;flex-direction:column;gap:10px;max-width:100%;';
    const STARS = {'ONE':1,'TWO':2,'THREE':3,'FOUR':4,'FIVE':5};
    reviews.forEach(function(r) {
      const card = document.createElement('div');
      card.style.cssText = 'background:rgba(30,41,59,0.6);border:1px solid rgba(148,163,184,0.15);border-radius:12px;padding:12px 14px;';
      const stars = STARS[r.rating] || 5;
      const starStr = '★'.repeat(stars) + '☆'.repeat(5 - stars);
      card.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
          <span style="font-size:12px;font-weight:600;color:#f1f5f9;">${r.author}</span>
          <span style="color:#facc15;font-size:13px;letter-spacing:1px;">${starStr}</span>
        </div>
        ${r.text ? `<div style="font-size:12px;color:#94a3b8;line-height:1.5;">"${r.text.slice(0,200)}${r.text.length>200?'…':''}"</div>` : ''}
      `;
      wrapper.appendChild(card);
    });
    const label = document.createElement('div');
    label.style.cssText = 'font-size:11px;color:#64748b;margin-top:4px;text-align:center;';
    label.innerHTML = '⭐ Google Reviews — <a href="https://g.page/r/CbWzs-H_5PJBEAI/review" target="_blank" style="color:#60a5fa;">see all reviews</a>';
    msg.appendChild(wrapper);
    msg.appendChild(label);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  function addShowroomCard() {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    msg.innerHTML = `<div style="background:rgba(30,41,59,0.6);border:1px solid rgba(148,163,184,0.2);border-radius:14px;padding:16px;max-width:85%;">
      <div style="font-size:11px;font-weight:700;letter-spacing:1px;color:#60a5fa;text-transform:uppercase;margin-bottom:6px;">📍 Showroom — Chelmsford, Essex</div>
      <div style="font-size:13px;color:#cbd5e1;margin-bottom:14px;line-height:1.5;">Come and see the quality in person before you order.</div>
      <div id="bib-showroom-btn-target"></div>
    </div>`;
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
    if (window.calendar && window.calendar.schedulingButton) {
      var calTarget = document.getElementById('bib-showroom-btn-target');
      window.calendar.schedulingButton.load({
        url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2u6JrmL4-OngXdYd1FT7iFZJ8-Z8XvBOruAGb4_DNu5aVMa6StxuDJZj5lQVBZGnvt9pviMWLY?gv=true',
        color: '#2563eb',
        label: 'Book an appointment',
        target: calTarget,
      });
      // Fire once when they open the booking flow (proxy for a showroom meeting request)
      calTarget.addEventListener('click', function () {
        bibTrack('chat_meet_sent', { event_category: 'BIB Chatbot', method: 'calendar' });
      }, { once: true });
    } else {
      document.getElementById('bib-showroom-btn-target').innerHTML =
        `<a href="https://www.branditessex.com/pages/showroom" target="_blank"
           onclick="window.bibTrack&&window.bibTrack('chat_meet_sent',{event_category:'BIB Chatbot',method:'showroom_page'})"
           style="display:block;text-align:center;background:#2563eb;color:#fff;font-size:13px;font-weight:700;padding:10px 16px;border-radius:9px;text-decoration:none;">
           Book an appointment →
         </a>`;
    }
  }

  function addEscalation() {
    const msg = document.createElement('div');
    msg.className = 'bib-message bib-bot';
    const banner = document.createElement('div');
    banner.className = 'bib-escalation-banner';
    banner.innerHTML = `<div class="bib-escalation-text">Need to talk to James?</div>
      <a class="bib-whatsapp-btn" href="https://api.whatsapp.com/send/?phone=447822032344" target="_blank" onclick="window.bibTrack&&window.bibTrack('chat_whatsapp_clicked',{event_category:'BIB Chatbot',source:'escalation'})">WhatsApp James</a>`;
    msg.appendChild(banner);
    messagesDiv.appendChild(msg);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  // ── Inactivity timer ─────────────────────────────────────────────────────
  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    if (conversationHistory.length < 2) return;
    if (sessionStorage.getItem('bib-lead-triggered')) return;
    inactivityTimer = setTimeout(function() {
      if (widget.classList.contains('bib-open')) triggerLeadCapture();
    }, INACTIVITY_MS);
  }

  // ── Lead capture trigger ──────────────────────────────────────────────────
  function triggerLeadCapture() {
    if (sessionStorage.getItem('bib-lead-triggered')) return;
    sessionStorage.setItem('bib-lead-triggered', '1');
    clearTimeout(inactivityTimer);
    leadCaptureActive = true;
    // Remove quote button if visible
    var qBtn = document.getElementById('bib-quote-btn');
    if (qBtn && qBtn.parentNode) qBtn.parentNode.removeChild(qBtn);
    // Open widget if closed (for button-triggered flow)
    if (!widget.classList.contains('bib-open')) openWidget();
    // Call API with the lead capture trigger
    addThinkingBox();
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: '__LEAD_CAPTURE_START__',
        history: conversationHistory.slice(-10),
        pageContext: window.__bibPageContext || null,
        leadCaptureMode: true,
        pagesVisited: pagesVisited,
        customer: window.__bibCustomer || null
      })
    }).then(function(r) { return r.json(); }).then(function(data) {
      removeThinkingBox();
      conversationHistory.push({ role: 'assistant', content: data.message });
      addBotMessage(data.message);
      if (data.leadCaptured) bibTrack('chat_lead_captured', { event_category: 'BIB Chatbot' });
      saveSession();
    }).catch(function() { removeThinkingBox(); });
  }

  // ── "Help me with a quote" button ─────────────────────────────────────────
  function showQuoteButton() {
    if (document.getElementById('bib-quote-btn')) return;
    if (sessionStorage.getItem('bib-lead-triggered')) return;
    var btn = document.createElement('button');
    btn.id = 'bib-quote-btn';
    btn.className = 'bib-quote-btn';
    btn.textContent = '💬 Help me with a quote';
    btn.addEventListener('click', function() {
      btn.parentNode && btn.parentNode.removeChild(btn);
      triggerLeadCapture();
    });
    var inputArea = document.querySelector('.bib-input-area');
    if (inputArea) inputArea.parentNode.insertBefore(btn, inputArea);
  }

  // ── Send message ────────────────────────────────────────────────────────
  async function sendMessage() {
    const message = inputField.value.trim();
    if (!message) return;
    addUserMessage(message);
    inputField.value = '';
    sendBtn.disabled = true;
    addThinkingBox();
    try {
      conversationHistory.push({ role: 'user', content: message });
      bibTrack('chat_message_sent', { event_category: 'BIB Chatbot' });
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          history: conversationHistory.slice(-10),
          pageContext: window.__bibPageContext || null,
          leadCaptureMode: leadCaptureActive,
          pagesVisited: leadCaptureActive ? pagesVisited : [],
          customer: window.__bibCustomer || null,
          shownHandles: shownProductHandles
        }),
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      removeThinkingBox();
      conversationHistory.push({ role: 'assistant', content: data.message });
      addBotMessage(data.message);
      if (data.productCards && data.productCards.length > 0) {
        addProductCards(data.productCards);
        lastSearchQuery = data.searchQuery || message;
        showChips(data.productType, lastSearchQuery);
        productSearchCount++;
        if (productSearchCount >= 3 && !sessionStorage.getItem('bib-lead-triggered')) {
          showQuoteButton();
        }
      }
      if (data.instagramPosts && data.instagramPosts.length > 0) addInstagramPosts(data.instagramPosts);
      if (data.googleReviews && data.googleReviews.length > 0) addGoogleReviews(data.googleReviews);
      if (data.showEscalation) addEscalation();
      if (data.message && data.message.includes('branditessex.com/pages/showroom')) addShowroomCard();
      if (data.leadCaptured) bibTrack('chat_lead_captured', { event_category: 'BIB Chatbot' });
      resetInactivityTimer();
    } catch (error) {
      removeThinkingBox();
      addBotMessage('Sorry, something went wrong. Please try again or WhatsApp us directly.');
    } finally {
      sendBtn.disabled = false;
      inputField.focus();
    }
  }

  // ── Open / close ────────────────────────────────────────────────────────
  function restoreMessages() {
    savedMessages.forEach(function(m) {
      if (m.type === 'bot') addBotMessage(m.text, true);
      else if (m.type === 'user') addUserMessage(m.text, true);
      else if (m.type === 'products') addProductCards(m.products, true);
    });
    setTimeout(function() { messagesDiv.scrollTop = messagesDiv.scrollHeight; }, 50);
  }

  // Body scroll lock for iOS — prevents page scrolling when keyboard opens inside widget
  var _scrollY = 0;
  function lockBodyScroll() {
    if (window.innerWidth > 480) return;
    _scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    if (window.innerWidth > 480) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, _scrollY);
  }

  function openWidget() {
    widget.classList.add('bib-animating');
    requestAnimationFrame(function() { widget.classList.add('bib-open'); });
    launcher.style.display = 'none';
    lockBodyScroll();
    widget.dispatchEvent(new CustomEvent('bib-opened'));
    if (!greeted) {
      if (savedMessages.length > 0) {
        restoreMessages();
      } else {
        addGreeting();
      }
      greeted = true;
    }
    setTimeout(function() { inputField.focus(); }, 300);
    resetInactivityTimer();
  }

  function closeWidget() {
    clearTimeout(inactivityTimer);
    widget.classList.remove('bib-open');
    unlockBodyScroll();
    setTimeout(function() {
      widget.classList.remove('bib-animating');
      launcher.style.display = '';
    }, 250);
  }

  // ── Events ──────────────────────────────────────────────────────────────
  launcher.addEventListener('click', openWidget);
  closeBtn.addEventListener('click', closeWidget);
  mobileHandle.addEventListener('click', closeWidget);
  sendBtn.addEventListener('click', sendMessage);
  inputField.addEventListener('keypress', function(e) { if (e.key === 'Enter') sendMessage(); });

  expandBtn.addEventListener('click', function() {
    isExpanded = !isExpanded;
    widget.classList.toggle('bib-expanded', isExpanded);
    expandIcon.textContent = isExpanded ? '⤡' : '⤢';
    expandBtn.title = isExpanded ? 'Shrink' : 'Expand';
  });

  // ── Resize widget when keyboard opens (body is locked so no jumping) ──────
  if (window.visualViewport && window.innerWidth <= 480) {
    var vvp = window.visualViewport;
    vvp.addEventListener('resize', function() {
      var kbHeight = window.innerHeight - vvp.height;
      if (kbHeight > 100) {
        widget.style.height = (vvp.height * 0.72) + 'px';
      } else {
        widget.style.height = '';
      }
    });
  }

  // ── Auto-restore session on new page load ───────────────────────────────
  // Only re-open if user navigated here from a chat link (?bib=1) AND has an active session
  if (savedMessages.length > 0 && window.location.search.indexOf('bib=1') !== -1) {
    setTimeout(function() { openWidget(); }, 800);
  }

  // ── Listen for exit-intent trigger from behaviour tracker ───────────────
  window.addEventListener('bie-open-chat', function() {
    if (!widget.classList.contains('bib-open')) openWidget();
  });

  // ── Voice to text ───────────────────────────────────────────────────────
  const micBtn = document.getElementById('bib-mic-btn');
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) {
    micBtn.style.display = 'none';
  } else {
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-GB';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    let listening = false;
    micBtn.addEventListener('click', function() {
      listening ? recognition.stop() : recognition.start();
    });
    recognition.addEventListener('start', function() {
      listening = true;
      micBtn.style.background = 'rgba(37,99,235,0.7)';
      micBtn.style.borderColor = '#2563eb';
      inputField.placeholder = 'Listening...';
    });
    recognition.addEventListener('end', function() {
      listening = false;
      micBtn.style.background = 'rgba(51,65,85,0.5)';
      micBtn.style.borderColor = 'rgba(148,163,184,0.2)';
      inputField.placeholder = 'Ask me anything...';
    });
    recognition.addEventListener('result', function(e) {
      inputField.value = e.results[0][0].transcript;
      sendMessage();
    });
    recognition.addEventListener('error', function() {
      inputField.placeholder = 'Ask me anything...';
      listening = false;
    });
  }

  // ── Load Google Calendar scheduling script ──────────────────────────────
  if (!document.querySelector('link[href*="calendar.google.com/calendar/scheduling-button-script.css"]')) {
    const calLink = document.createElement('link');
    calLink.rel = 'stylesheet';
    calLink.href = 'https://calendar.google.com/calendar/scheduling-button-script.css';
    document.head.appendChild(calLink);
  }
  if (!document.querySelector('script[src*="calendar.google.com/calendar/scheduling-button-script.js"]')) {
    const calScript = document.createElement('script');
    calScript.src = 'https://calendar.google.com/calendar/scheduling-button-script.js';
    calScript.async = true;
    document.head.appendChild(calScript);
  }

})();
